import React from 'react';
import './Sidebar.css';
import { useSidebar } from '../../../context/SidebarContext';
import { Link, useLocation } from 'react-router-dom';

interface SidebarProps {
  // Add any props if needed
}

const Sidebar: React.FC<SidebarProps> = () => {
  const location = useLocation();
  const { menu, isSidebarOpen } = useSidebar();

  return (
    <aside
      id="sidebar"
      className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}
      style={{ position: 'fixed', height: '100vh', left: 0, top: 0 }}
    >
      {menu.items.map((item, index) => (
        <Link
          key={index}
          to={item.path}
          style={{ textDecoration: 'none' }}
          className={`sidebar-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
        >
          <div className="sidebar-item-icon" style={{ color: location.pathname === item.path ? '#7c3aed' : 'black' }}>
            {/* <item.icon color={location.pathname.startsWith(item.path) ? '#7c3aed' : 'black'} /> */}
          </div>
          <span>{item.label}</span>
        </Link>
      ))}
    </aside>
  );
};

export default Sidebar;
